var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-3 py-3",attrs:{"fluid":""}},[_c('v-card',[_c('v-card-title',[_vm._v("List Service: Import")]),_c('v-card-text')],1),_c('import-file-upload',{on:{"uploaded":_vm.onFileUpload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }